import React, { useContext, useEffect, useState } from "react";
import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import { FaSearch, FaMapMarkerAlt } from "react-icons/fa";
import Select from "react-select";
import { CityLookupList } from "../ApiServices/Other/StateLookupListApi";
import { LoaderContext } from "../AuthContext/AuthContext";
import { customSelectStyles } from "../middlewares/Utils";
const LocationModal = ({ show, onHide, onSelectCity }) => {
  const [search, setSearch] = useState("");
  const { setLoader, loader, isLocationUpdate, setIsLocationUpdate } =
    useContext(LoaderContext);
  const [selectedCity, setSelectedCity] = useState("");
  const [cityLookupList, setCityLookupList] = useState([]);
  const [error, setError] = useState(false)
  const cities = [
    "Mumbai",
    // "Navi Mumbai",
    "Thane",
    "Pune",
    "Delhi",
    "Chennai",
    "Bangalore",
    "Coimbatore",
    "Gurugram",
  ];

  useEffect(() => {
    GetCityLookupListData(null);
  }, []);

  const handleDetectLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          try {
            const response = await fetch(
              `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
            );
            const data = await response.json();

            // Full formatted address
            const fullAddress = data.display_name;

            if (fullAddress) {
              alert(`Your full address is:\n${fullAddress}`);
              // You can also extract specific fields if needed
              setSelectedCity(
                data.address.city,
                data.address.town,
                data.address.village
              );
            }
          } catch (error) {
            console.error("Error fetching location:", error);
          }
        },
        () => alert("Location access denied!")
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  const GetCityLookupListData = async (ID) => {
    setLoader(true);
    try {
      const response = await CityLookupList(ID); // Ensure it's correctly imported

      if (response?.ResponseCode === "0") {
        setLoader(false);
        const languageLookupList = response?.DATA || [];

        const formattedLangList = languageLookupList.map((Lang) => ({
          value: Lang.DistrictID,
          label: Lang.DistrictName,
        }));

        setCityLookupList(formattedLangList);
      } else {
        setLoader(false);
        console.error(
          "Failed to fetch sim Type lookup list:",
          response?.data?.statusMessage || "Unknown error"
        );
      }
    } catch (error) {
      setLoader(false);
      console.error("Error fetching sim Type lookup list:", error);
    }
  };

  const HandleContinueBtnClicked = (selectedCity) => {
    let isValid = true
    if (selectedCity === null || selectedCity === undefined || selectedCity === '') {
      setError(true)
      isValid = false
    }

    if (isValid) {
      closeAll()
    }
  }

  const closeAll = () => {
    onSelectCity(selectedCity);
    setError(false)
    onHide();
  }
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Pick a Location</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Search Input */}
        <div style={{ width: "100%" }} className="mb-3">
          <Select

            styles={customSelectStyles}
            options={cityLookupList}
            onChange={(selectedOption) => {
              setSelectedCity(selectedOption?.label);
            }}
            value={cityLookupList.find((item) => item.label === selectedCity)}

            placeholder="Enter City Name"
          />
          {error && (selectedCity === null ||
            selectedCity === undefined ||
            selectedCity === "") ? (
            <span className="error-msg">This field is required</span>
          ) : (
            ""
          )}
        </div>

        {/* <InputGroup className="mb-3">
          <Form.Control
            type="text"
            placeholder="Enter City or Pin Code"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <InputGroup.Text>
            <FaSearch style={{ background: "white" }} />
          </InputGroup.Text>
        </InputGroup> */}

        {/* Detect Location */}
        {/* <div
          className="d-flex align-items-center mb-3 detect-location-div"
          style={{ cursor: "pointer" }}
          onClick={handleDetectLocation}
        >
          <FaMapMarkerAlt className="me-2" />
          Detect My Location
        </div> */}

        {/* Popular Cities */}
        <h6 className="mb-2">Popular Cities</h6>
        <div className="d-flex flex-wrap gap-2">
          {cities.map((city, index) => (
            <Button
              key={index}
              // variant={selectedCity === city ? "primary" : "outline-secondary"}
              className="rounded-pill pick-city-btn"
              onClick={() => setSelectedCity(city)}
              style={{
                textTransform: "none",
                backgroundColor: "white",
                color: "black",
                border:
                  selectedCity === city
                    ? "1px solid #a52444"
                    : "1px solid lightgray",
                borderRadius: "10px",
              }}
            >
              {city}
            </Button>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="Normal-app-btn"
          style={{ padding: "5px 16px", fontSize: "14px" }}
          onClick={() => HandleContinueBtnClicked(selectedCity)}
        // disabled={!selectedCity}
        >
          Continue
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default LocationModal;
